var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { getOwner } from '@ember/application';
import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import * as Sentry from '@sentry/browser';
import * as singleSpa from 'single-spa';
import 'systemjs';
const LOCALHOST_DEV_PORT = '5173';
const API_PATH = '/staff-fe/api/dashboard-spa-manifest';
let StaffFeService = (_class = class StaffFeService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "environment", _descriptor, this);
    _initializerDefineProperty(this, "employeeInfo", _descriptor2, this);
    _initializerDefineProperty(this, "userInfo", _descriptor3, this);
    _initializerDefineProperty(this, "applicationRouter", _descriptor4, this);
    _defineProperty(this, "modules", {});
    _defineProperty(this, "parcel", void 0);
    _defineProperty(this, "cdnOrigin", void 0);
    _defineProperty(this, "bundles", {});
    _defineProperty(this, "parcelConfig", {
      bootstrap: () => Promise.resolve(),
      mount: () => Promise.resolve(),
      unmount: () => Promise.resolve(),
      update: () => Promise.resolve()
    });
    _initializerDefineProperty(this, "mountFailure", _descriptor5, this);
    _initializerDefineProperty(this, "apiEndpointFailure", _descriptor6, this);
  }
  async setupApp(bundleName, domElement, customProps) {
    const mfeBundleUrl = await this.loadManifestData(bundleName);
    if (mfeBundleUrl) {
      try {
        singleSpa.start();
        this.modules[bundleName] = await System.import(mfeBundleUrl);
        if (this.modules[bundleName]) {
          await this.mountApplication(this.modules[bundleName], domElement, customProps);
        }
      } catch (e) {
        this.mountFailure = true;
        Sentry.captureException(e);
      }
    } else {
      this.apiEndpointFailure = true;
    }
  }
  async preloadApp(bundleName) {
    // If the module is already loaded we don't need to preload it again
    if (this.modules[bundleName]) {
      return this.modules[bundleName];
    }
    const emptyDOMElement = document.createElement('div');
    const mfeBundleUrl = await this.loadManifestData(bundleName);
    if (mfeBundleUrl) {
      try {
        singleSpa.start();
        this.modules[bundleName] = await System.import(mfeBundleUrl);
        if (this.modules[bundleName]) {
          await this.mountApplication(this.modules[bundleName], emptyDOMElement, {
            preload: true,
            ...this.customProps
          });
        }
      } catch (e) {
        Sentry.captureException(e);
      }
    }
    return this.modules[bundleName];
  }
  async mountApplication(module, domElement, customProps) {
    this.parcelConfig = {
      bootstrap: module.bootstrap,
      mount: module.mount,
      unmount: module.unmount,
      update: module.update
    };
    const parcelProps = {
      domElement,
      ...customProps
    };
    this.parcel = singleSpa.mountRootParcel(this.parcelConfig, parcelProps);
    await this.parcel.mountPromise;
  }
  async loadManifestData(bundle) {
    if (this.cdnOrigin && this.bundles[bundle]) {
      return `${this.cdnOrigin}/${this.bundles[bundle]}`;
    }
    let responseJson;
    try {
      const response = await fetch(this.endpoint);
      if (response.ok) {
        responseJson = await response.json();
      } else {
        throw new Error(`Bad response code ${response.status} from staff-fe API endpoint`);
      }
    } catch (e) {
      Sentry.captureException(e);
    }
    const {
      cdnOrigin,
      ...bundles
    } = responseJson?.app ?? {};
    this.cdnOrigin = cdnOrigin;
    this.bundles = bundles;
    return `${cdnOrigin}/${bundles[bundle]}`;
  }
  get config() {
    return getOwner(this).resolveRegistration('config:environment');
  }
  get endpoint() {
    const {
      isProduction,
      isSandbox,
      isTesting,
      isDevelopment
    } = this.environment;
    if (this.useLocalIntegration && isDevelopment) {
      return `http://localhost:${LOCALHOST_DEV_PORT}${API_PATH}`;
    } else if (isTesting) {
      return API_PATH;
    } else if (isProduction || isSandbox) {
      return `https://app.squareup.com${API_PATH}`;
    } else {
      return `https://app.squareupstaging.com${API_PATH}`;
    }
  }

  // In development, most users will not be running the integration
  // server for a micro frontend, so the default should be to use
  // its staging URL.
  // When a developer has the integration server running, they can
  // manually change useLocalIntegration to `true`.
  // For a developer that often wants integration mode, you can set the
  // INTEGRATION_STAFF_FE env variable to 'true'. Note that
  // the env variable must be set before starting the dashboard dev server.
  get useLocalIntegration() {
    return this.config.dashboardMFE?.['staff-fe']?.enabled;
  }
  get customProps() {
    const {
      merchantToken,
      employmentToken,
      countryCode,
      languageCode,
      isJP,
      browserLanguage,
      currencyCode
    } = this.userInfo;
    const {
      canManageScheduleRequests,
      canViewWagesInShifts,
      canManageSchedules
    } = this.employeeInfo;
    return {
      userInfo: {
        merchantToken,
        employmentToken,
        countryCode,
        languageCode,
        isJP,
        browserLanguage,
        currencyCode
      },
      employeePermissions: {
        canManageScheduleRequests,
        canViewWagesInShifts,
        canManageSchedules
      },
      teamMembersBaseRoute: 'team.team_members',
      applicationRouter: this.applicationRouter
    };
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "environment", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "employeeInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "applicationRouter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "mountFailure", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "apiEndpointFailure", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
})), _class);
export { StaffFeService as default };